import CTAButton from "../../components/CTAButton/CTAButton";
import StepCard from "../../components/StepCard/StepCard";
import VerticalTextSlide from "../../components/VerticalTextSlide/VerticalTextSlide";
import VideoSection from "../../components/VideoSection/VideoSection";
import styles from "./Home.module.css";
import { useState, useRef } from "react";
import Modal from "../../components/Modal/Modal";
import { faqData } from "../../data/faqData";
// import FlodeskForm from "../components/FlodeskForm";
import useFocusTrap from "../../hooks/useFocusTrap";
import PageLayout from "../../components/PageLayout/PageLayout";
import AccordionContainer from "../../components/AccordionContainer/AccordionContainer";

function HomePage() {
    const modalContainerRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [animationState, setAnimationState] = useState(true);

    useFocusTrap(modalContainerRef, showModal, {});

    function handleSetShowModal(val) {
        if (val) {
            setTimeout(() => {
                modalContainerRef.current
                    .querySelector('[aria-label="Close sign up modal"]')
                    .focus();
            }, 1);

            modalContainerRef.current.style.display = "flex";
        } else {
            setTimeout(() => {
                modalContainerRef.current.style.display = "none";
            }, 500);
        }

        setShowModal(val);
    }

    function defaultCTAHandler() {
        handleSetShowModal(true);
    }

    function toggleAnimationHandler() {
        setAnimationState((prev) => {
            document
                .querySelectorAll("[data-play-pause='animation']")
                .forEach(
                    (el) =>
                        (el.style.animationPlayState = prev
                            ? "paused"
                            : "running")
                );

            document
                .querySelectorAll("[data-play-pause='video']")
                .forEach((el) => {
                    if (prev) {
                        el.pause();
                    } else {
                        el.play();
                    }
                });

            return !prev;
        });
    }

    return (
        <PageLayout headerCTAHandler={defaultCTAHandler}>
            <Modal
                showModal={showModal}
                setShowModal={handleSetShowModal}
                modalContainerRef={modalContainerRef}
            />
            <VideoSection
                sectionClassName={styles.home_hero_section}
                videoId={"home-hero-video"}
                video={"/home-hero-video.mp4"}
                image={"/home-hero-first-frame.webp"}
                key={"home-hero"}
                color={"#04013f96"}
                videoDescription={
                    "A silent video of a young woman sitting on a bed. She looks off to the side, places her head on her hands and sighs. She leans back and the video blurs."
                }
            >
                <div className={styles.home_hero_content}>
                    <div id={styles.home_hero_top}>
                        <VerticalTextSlide
                            prefix={"Feeling "}
                            options={[
                                "Anxious?",
                                "Stressed?",
                                "Depressed?",
                                "Alone?",
                                "Stuck?",
                            ]}
                            id={styles.home_vertical_text_slide}
                        />

                        <div className={"hero-controls"}>
                            <button
                                onClick={toggleAnimationHandler}
                                aria-label={`${
                                    animationState ? "Pause" : "Resume"
                                } text animation and background video`}
                            >
                                <img
                                    src={`/${
                                        animationState ? "pause" : "play"
                                    }-icon.png`}
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>
                    <strong
                        style={{
                            color: "white",
                            fontSize: 36,
                            lineHeight: "42px",
                            marginBlock: 10,
                        }}
                    >
                        You are here. So are we.
                    </strong>{" "}
                    <p style={{ color: "white" }}>
                        We understand the challenges you may be facing. We are
                        here to provide you with support, connection, and a way
                        forward.
                    </p>
                    <CTAButton onClick={defaultCTAHandler}>
                        Start your journey
                    </CTAButton>
                </div>
            </VideoSection>
            <section
                className={styles.about_section}
                style={{
                    backgroundImage: "url('/about_section_bg.svg')",
                }}
            >
                <div className={styles.step_card_row}>
                    <StepCard
                        icon={"step1_icon.png"}
                        heading={"Step 1"}
                        alt={"Survey"}
                        description={
                            "Register with your postsecondary school email and follow the steps to create an account."
                        }
                    />

                    <StepCard
                        icon={"step2_icon.png"}
                        heading={"Step 2"}
                        alt={"Get matched with a care provider"}
                        description={
                            "Choose a care provider from a list of recommended matches."
                        }
                    />

                    <StepCard
                        icon={"step3_icon.png"}
                        heading={"Step 3"}
                        alt={"Book session"}
                        description={
                            "Book your first session and start feeling better today."
                        }
                    />
                </div>
                <div className={styles.about_item} id={styles.matters}>
                    <div className={styles.matters_graphic}>
                        <p
                            id={styles.woman_on_couch_description}
                            className={styles.background_image_description}
                        >
                            Woman sitting on a couch, using a laptop on her lap.
                        </p>
                        <div
                            className={styles.overlay_img_small}
                            style={{
                                backgroundImage: "url(/woman_on_couch.jpg)",
                            }}
                            role="img"
                            aria-labelledby={styles.woman_on_couch_description}
                        ></div>
                        <img
                            src="/phone_mockup.png"
                            className={styles.overlay_img_floating}
                            draggable="false"
                            alt="Mobile app dashboard showing My Care Providers, Upcoming sessions and various messaging features"
                        />
                    </div>
                    <div className={styles.content}>
                        <h2 className={styles.subheading}>
                            Your mental health matters.
                        </h2>
                        <p>
                            Keel Mind provides counselling to students at
                            colleges and universities in Ontario at no cost to
                            you.
                            <br />
                            <br />
                            All appointments are confidential and offered online
                            on a day and time that work best for YOU.
                        </p>
                    </div>
                </div>

                <div
                    className={[
                        styles.about_item,
                        styles.overlay_grid,
                        styles.right,
                    ].join(" ")}
                    id={styles.help}
                >
                    <div className={styles.content}>
                        <h2 className={styles.subheading}>
                            Are you a student seeking help?
                        </h2>
                        <p>
                            You are not alone. We can connect you to a care
                            provider that can help with whatever your needs may
                            be, including:
                        </p>
                        <div className={styles.double_ul}>
                            <ul className={styles.double_ul_list}>
                                <li>Depression</li>
                                <li>School Stress</li>
                                <li>Anxiety</li>
                                <li>Self-esteem</li>
                                <li>Addiction</li>
                            </ul>
                            <ul className={styles.double_ul_list}>
                                <li>Anger</li>
                                <li>Relationships</li>
                                <li>Grief</li>
                                <li>Disordered eating</li>
                                <li>Mental Wellness</li>
                            </ul>
                        </div>
                        <p>...and more.</p>
                    </div>
                    <div
                        className={styles.graphic}
                        style={{
                            backgroundImage: "url('/man_on_floor.jpg')",
                        }}
                        aria-labelledby={styles.man_on_floor_description}
                        role="img"
                    ></div>
                    <p
                        className={styles.background_image_description}
                        id={styles.man_on_floor_description}
                    >
                        Young man sitting on the floor with his back against a
                        concrete column, while surrounded by a pile of books, a
                        backpack, and a notepad.
                    </p>
                </div>

                <div
                    className={[
                        styles.about_item,
                        styles.overlay_grid,
                        styles.left,
                    ].join(" ")}
                    id={styles.mind}
                >
                    <div className={styles.content}>
                        <h2 className={styles.subheading}>Why Keel Mind?</h2>
                        <div className={styles.why_grid}>
                            <div className={styles.why_item}>
                                <img
                                    src="/approachable.png"
                                    alt=""
                                    className={styles.why_icon}
                                />
                                <p>
                                    <strong>Approachable:</strong> get support
                                    from trained, relatable care providers.
                                </p>
                            </div>
                            <div>
                                <div className={styles.why_item}>
                                    <img
                                        src="/confidential.png"
                                        alt=""
                                        className={styles.why_icon}
                                    />
                                    <p>
                                        <strong>Confidential:</strong> private,
                                        anonymous if you wish.
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div className={styles.why_item}>
                                    <img
                                        src="/accessible.png"
                                        alt=""
                                        className={styles.why_icon}
                                    />
                                    <p>
                                        <strong>Accessible:</strong> speak to
                                        your care provider virtually, where and
                                        when you need to.
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div className={styles.why_item}>
                                    <img
                                        src="/ongoing.png"
                                        alt=""
                                        className={styles.why_icon}
                                    />
                                    <p>
                                        <strong>Ongoing:</strong> a platform you
                                        can use now, and later, to track your
                                        mental fitness goals.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p
                        id={styles.woman_at_table_description}
                        className={styles.background_image_description}
                    >
                        Young woman sitting at a table, using a smartphone.
                    </p>
                    <div
                        role="img"
                        className={styles.graphic}
                        style={{
                            backgroundImage: "url('/woman_at_table.png')",
                        }}
                        aria-labelledby={styles.woman_at_table_description}
                    ></div>
                </div>
            </section>
            <section className={styles.faq_section}>
                <div className={styles.bg_section}>
                    <img
                        src="/woman_on_grass.png"
                        alt=""
                        className={styles.faq_image}
                    />
                    <div className={styles.overlay_color}></div>
                </div>
                <div className={styles.top_content}>
                    <div>
                        <h2>We're ready when you are.</h2>
                        <p>
                            We understand the challenges you may be facing. We
                            are here to provide you with support, connection,
                            and a way forward.
                        </p>
                    </div>
                    <CTAButton onClick={defaultCTAHandler}>
                        Start your journey
                    </CTAButton>
                </div>
                <AccordionContainer data={faqData} />
            </section>
        </PageLayout>
    );
}

export default HomePage;
